import { render, staticRenderFns } from "./CopyrightAssignmentTransferFormsDetails.vue?vue&type=template&id=6c3a53b0&scoped=true&"
import script from "./CopyrightAssignmentTransferFormsDetails.vue?vue&type=script&lang=js&"
export * from "./CopyrightAssignmentTransferFormsDetails.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAssignmentTransferFormsDetails.vue?vue&type=style&index=0&id=6c3a53b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3a53b0",
  null
  
)

export default component.exports